export enum CustomerStatus {
  Verified = "verified",
  Pending = "pending",
}

export enum Status {
  Pending = "pending",
  Completed = "completed",
  Approved = "Approved",
  Rejected = "Rejected",
  Success = "Success",
  PENDING = "Pending",
  Processing = "Processing",
  FEEDBACK_REQUIRED = 'FEEDBACK_REQUIRED',
  Opened = "Opened",
  Active = "Active",
  pending = "Pending",
  PENDING_PAYMENT = "PENDING_PAYMENT",
  Blocked = 'Blocked',
  Closed = 'Closed'
}

export enum ReviewMessageKey {
  PERSONAL = 'Personal',
  PROFESSIONAL = 'Professional',
  COMMUNICATION = 'Communication',
  FINANCIAL = 'Financial',
  FATCA_CRS = 'Fatca_Crs',
  BANK_ACCOUNTS = 'Bank_Accounts',
  CONTACT_PERSONS = 'Contact_Persons',
  DOCUMNETS = 'Documents',
}

export enum RequestsType {
  SUBSCRIPTION = "SUBSCRIPTION",
  DEPOSIT = "DEPOSIT",
  WITHDRAW = "WITHDRAW",
  REDEMPTION = "REDEMPTION",
}